import React, { Fragment } from 'react';
import { reviewBudget } from '../Helpers';
import PropTypes from 'prop-types';

const ControlBudget = ({ budget, remaining }) => {
    return (
        <Fragment>
            <div className="alert alert-primary">
                Presupuesto: $ {budget}
            </div>
            <div className={reviewBudget(budget, remaining)}>
                Restante: $ {remaining}
            </div>
        </Fragment>
    );
}

ControlBudget.propTypes = {
    budget: PropTypes.number.isRequired,
    remaining: PropTypes.number.isRequired
}

export default ControlBudget;